class AdhyaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-adhya-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-adhya-dot]'));
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.interval = Number(this.dataset.interval || 6500);

    this.querySelector('[data-adhya-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
    this.querySelector('[data-adhya-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  show(nextIndex, restart = false) {
    if (this.slides.length < 2) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    this.dots.forEach((dot, index) => {
      const active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if (restart) {
      this.stop();
      this.start();
    }
  }

  start() {
    if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stop();
    this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('adhya-hero')) {
  customElements.define('adhya-hero', AdhyaHero);
}

function syncCustomPrintingLinks(root = document) {
  const customUrl = document.body?.dataset.adhyaCustomUrl;
  if (!customUrl) return;

  const links = root.matches?.('header') ? root.querySelectorAll('a[href]') : root.querySelectorAll('header a[href]');
  links.forEach((link) => {
    const label = link.textContent.replace(/\s+/g, ' ').trim();
    const path = new URL(link.href, window.location.origin).pathname;
    if (label === 'Custom' && path === '/pages/contact') link.href = customUrl;
  });
}

syncCustomPrintingLinks();
document.addEventListener('shopify:section:load', (event) => syncCustomPrintingLinks(event.target));

document.querySelectorAll('header').forEach((adhyaHeader) => {
  new MutationObserver(() => syncCustomPrintingLinks(adhyaHeader)).observe(adhyaHeader, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener(
  'click',
  (event) => {
    const link = event.target.closest?.('header a[href]');
    const customUrl = document.body?.dataset.adhyaCustomUrl;
    if (!link || !customUrl) return;

    const label = link.textContent.replace(/\s+/g, ' ').trim();
    const path = new URL(link.href, window.location.origin).pathname;
    if (label !== 'Custom' || path !== '/pages/contact') return;

    event.preventDefault();
    window.location.assign(customUrl);
  },
  true
);
